import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Paper from '@mui/material/Paper';
import {grey} from '@mui/material/colors';
import { Box, Button } from '@mui/material';
import {getIcon} from '../../base';


const s:any = {
  paper: {
    flex: 1,
    width: '100%',
    maxWidth: '100%',
  },
  button: {
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    textTransform: 'none',
    padding: 0,
    minHeight: 80,
  },
  buttonContent: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    height: '100%',
  },
  iconSpan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    minHeight: '100%',
    width: 60,
    textAlign: 'center',
    marginRight: 2,
  },
  icon: {
    fontSize: 32,
    fill: 'white',
    color: 'white',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
    padding: '8px 0',
  },
  text: {
    fontSize: 18,
    fontWeight: 500,
    color: grey['800'],
    lineHeight: 1.2,
  },
  number: {
    display: 'block',
    fontWeight: 'typography.fontWeightMedium',
    fontSize: 18,
    color: grey['800']
  }
};

class MenuBox extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      test: null
    };
  }

  render() {
    const {color, title, value, icon, onClick, classes = {}} = this.props;
    const extras = {
      span:{backgroundColor: color}
    };
    const Icon = getIcon(icon);
    return (
      <Paper sx={{...s.paper}}>
        <Button onClick={onClick} sx={{...s.button}}>
          <Box sx={{...s.buttonContent}}>
            <Box component='span' sx={{...s.iconSpan, backgroundColor: color}}>
              <Icon color={'inherit'} sx={{...s.icon}} />
            </Box>
            <Box sx={{...s.content}}>
              <Box component='span' sx={{...s.text}}>{title}</Box>
              {value && (
                <Box component='span' sx={{...s.number}}>{value}</Box>
              )}
            </Box>
          </Box>
        </Button>
      </Paper>
      );
  }
}

MenuBox.propTypes = {
  Icon: PropTypes.any, // eslint-disable-line
  color: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.any
};

// export default InfoBox;
export default MenuBox;
